import _ from "lodash";
export const isArrayEqual = function (x, y) {
  let isLengthEqual = x.length === y.length;
  return isLengthEqual ? _(x).differenceWith(y, _.isEqual).isEmpty() : false;
};

export function downloadCsv(csvStr, filename) {
  const str = `data:text/csv;charset=utf-8,${csvStr}`;
  let encodedUri = encodeURI(str);
  const a = document.createElement("a");
  encodedUri = encodedUri.replace("#", "%23");
  a.href = encodedUri;
  a.setAttribute("download", `${filename}.csv`);
  a.click();
}

export function downlaodCsvLargeFile(csvStr, filename) {
  var link = document.createElement("a");
  var blob = new Blob([csvStr], { type: "text/csv;charset=utf-8;" });
  var url = URL.createObjectURL(blob);
  link.href = url;
  link.setAttribute("download", `${filename}.csv`);
  link.click();
}

export function downloadDoc(docStr, type, filename) {
  let blob = new Blob([docStr], { type: type });
  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;
  link.click();
}

export function isZeroOrNotEmpty(value) {
  if (value || value == 0) return true;
  else return false;
}

export const isTokenPresent = () => {
  let token = localStorage.getItem("tokenAdmin");
  // console.log("inside istokenpresenttt!!!!!!",token)
  if (token && token !== "null") return true;
  else return false;
};

export function downloadLargeFile(docStr, type, filename, dFilename) {
  const dynamicFilename = dFilename.split('filename=')[1].split(';')[0];
  const blob = new Blob([docStr], { type });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = dynamicFilename || filename;
  link.click();
}